module.exports = __webpack_public_path__ + "static/spk-558c3bd318601b46a30573369844a104.svg";